import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';
import isPurgeApproaching from '@UI/Store/Beneficiaries/Views/isPurgeApproaching';
import SubjectValuesView from '@UI/Store/Subjects/Views/SubjectValuesView';

/** Immutable View of a dossier of a configurable type. */
class SubjectView {
	readonly id: number;
	readonly facilityId: number;
	readonly typeId: number;
	readonly title: string | null;
	readonly createdAt: Date;
	/** `null` while the dossier is active. */
	readonly archivedAt: Date | null;
	/** Read on the detail only; `null` on a list entry and on an active dossier. */
	readonly purgeScheduledAt: Date | null;
	readonly canWrite: boolean;
	readonly canShare: boolean;
	readonly values: SubjectValuesView;

	constructor(payload: SubjectPayload) {
		this.id = payload.id;
		this.facilityId = payload.facility.id;
		this.typeId = payload.type.id;
		this.title = payload.title;
		this.createdAt = new Date(payload.createdAt);
		this.archivedAt =
			payload.archivedAt !== undefined && payload.archivedAt !== null
				? new Date(payload.archivedAt)
				: null;
		this.purgeScheduledAt =
			payload.purgeScheduledAt !== undefined && payload.purgeScheduledAt !== null
				? new Date(payload.purgeScheduledAt)
				: null;
		this.canWrite = payload.canWrite ?? false;
		this.canShare = payload.canShare ?? false;
		this.values = new SubjectValuesView(payload.values);

		Object.freeze(this);
	}

	get isArchived(): boolean {
		return this.archivedAt !== null;
	}

	/** An archived dossier is read-only for everyone: the write right alone no longer opens a gesture. */
	get canModify(): boolean {
		return this.canWrite && !this.isArchived;
	}

	get canManageMembers(): boolean {
		return this.canShare && !this.isArchived;
	}

	get isPurgeApproaching(): boolean {
		return this.isArchived && isPurgeApproaching(this.purgeScheduledAt);
	}
}

export default SubjectView;
